import React from 'react';
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Paper, TextField, MenuItem, Checkbox, Typography 
} from '@mui/material';
import { categories, timeIntervals } from '../constants/options';

const AldreteTable = ({ 
  formData, handleScoreChange, handleBaseTimeChange, 
  handleAdmTimeChange, handleDischargeTimeChange, handleCheckboxClick 
}) => {
  return (
    <TableContainer component={Paper} sx={{ marginTop: 3, overflowX: 'auto' }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
            <TableCell><b>Category</b></TableCell>
            {timeIntervals.map((time) => (
              <TableCell key={time} align="center"><b>{time}</b></TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {categories.map((cat, catIndex) => (
            <TableRow key={cat.name} hover>
              <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }}>{cat.name}</TableCell>
              {timeIntervals.map((time, timeIndex) => (
                <TableCell key={timeIndex} align="center">
                  {time === "Pre-Anesthesia Vital Signs" ? (
                    <TextField
                      select
                      size="small"
                      fullWidth
                      value={formData.scores[catIndex][timeIndex] !== undefined ? formData.scores[catIndex][timeIndex] : 0}
                      onChange={(e) => handleScoreChange(catIndex, timeIndex, e)}
                      sx={{ minWidth: 150 }}
                    >
                      {cat.options.map((option, optionIndex) => (
                        <MenuItem key={optionIndex} value={optionIndex}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : time === "Time" ? (
                    <TextField
                      type="time"
                      size="small"
                      value={formData.baseTime[catIndex] || ""}
                      onChange={(e) => handleBaseTimeChange(catIndex, e.target.value)}
                      fullWidth
                      sx={{ minWidth: 100 }}
                    />
                  ) : time === "Adm" ? (
                    <TextField
                      type="text"
                      size="small"
                      variant="standard"
                      value={formData.admTime[catIndex] || ""}
                      onChange={(e) => handleAdmTimeChange(catIndex, e.target.value)}
                      fullWidth
                      sx={{ minWidth: 80 }}
                    />
                  ) : time === "Discharge" ? (
                    <TextField
                      type="time"
                      size="small"
                      value={formData.dischargeTime[catIndex] || ""}
                      onChange={(e) => handleDischargeTimeChange(catIndex, e.target.value)}
                      fullWidth
                      sx={{ minWidth: 100 }}
                    />
                  ) : (
                    <div className="flex flex-col items-center">
                      <Checkbox
                        checked={formData.checkboxStates[catIndex][timeIndex] || false}
                        onChange={() => handleCheckboxClick(catIndex, timeIndex)}
                        size="small"
                      />
                      {formData.timeValues[catIndex][timeIndex] && (
                        <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>
                          {formData.timeValues[catIndex][timeIndex]}
                        </Typography>
                      )}
                    </div>
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
          <TableRow sx={{ backgroundColor: '#fafafa' }}>
            <TableCell><b>Total Score</b></TableCell>
            {formData.totalScores.map((total, index) => (
              <TableCell key={index} align="center" sx={{ fontWeight: 'bold' }}>
                {index === 1 || index === 2 || index === 10 ? '' : total}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AldreteTable;
